import { HttpClient } from "@angular/common/http";
import { DataService } from "../../core/services/data.service";
import { NotificationService } from "../../core/services/notification.service";
import { ReclamationDeviceDto } from "../models/reclamation/reclamation-device.dto";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ReclamationDeviceDeviceModelDto } from "../models/reclamation/reclamation-device-device-model.dto";

@Injectable()
export class ReclamationDevicesService extends DataService<ReclamationDeviceDto, ReclamationDeviceDto> {

    constructor(http: HttpClient, notificationService: NotificationService) {
        super(http, notificationService);
        this.controllerName = 'reclamation-devices';
    }

    getAll(): Observable<ReclamationDeviceDto[]> {
        return this.getQuery<ReclamationDeviceDto[]>(`${this.baseUrl()}/all`);
    }

    getAllReclamationDeviceModels(): Observable<ReclamationDeviceDeviceModelDto[]> {
        return this.getQuery<ReclamationDeviceDeviceModelDto[]>(`${this.baseUrl()}/all-reclamation-models`);
    }

    updateReclamationRequestDevice(requestId: number, reclamationDeviceId: number): Observable<any> {
        return this.postQuery(`${this.baseUrl()}/update-request-reclamation-device`, {
            requestId: requestId,
            reclamationDeviceId: reclamationDeviceId
        });    }
}